import { validate, isRequired, AgreementCheck } from '../../../services/validator'

import { METHODS } from './constants'

function getRulesOfMethod (key) {
  switch (key) {
    case METHODS.Cash:
      return {
        method: [isRequired],
        isAgree: [AgreementCheck]
      }
    case METHODS.Card:
      return {
        method: [isRequired],
        isAgree: [AgreementCheck]
      }
    case METHODS.Balance:
      return {
        method: [isRequired],
        isAgree: [AgreementCheck]
      }
    default:
      throw new Error('undefined method key')
  }
}

export function validateCreatePaymentForm (values) {
  return validate(values, getRulesOfMethod(+values.method))
}



// WEBPACK FOOTER //
// ./src/modules/home/tariffBuy/validate.js